import React from 'react'
import { Icon, useT } from '../shared'
import { useTheme } from '../lib/theme'

// Pemilih tema: Sistem / Terang / Gelap. Satu tombol ikon yang membuka menu kecil.
// `className` menyesuaikan gaya tombol dengan tempatnya (icon-btn di Topbar,
// topnav-btn di header mobile).
export default function ThemeToggle({ className = 'icon-btn' }) {
  const t = useT()
  const { pref, resolved, setPref } = useTheme()
  const [open, setOpen] = React.useState(false)
  const wrapRef = React.useRef(null)
  const btnRef = React.useRef(null)

  React.useEffect(() => {
    if (!open) return undefined
    const onDown = (e) => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false) }
    const onKey = (e) => { if (e.key === 'Escape') { setOpen(false); btnRef.current?.focus() } }
    document.addEventListener('mousedown', onDown)
    document.addEventListener('keydown', onKey)
    return () => {
      document.removeEventListener('mousedown', onDown)
      document.removeEventListener('keydown', onKey)
    }
  }, [open])

  const options = [
    ['system', t.themeSystem, 'monitor'],
    ['light', t.themeLight, 'sun'],
    ['dark', t.themeDark, 'moon'],
  ]

  return (
    <div className="theme-toggle" ref={wrapRef}>
      <button
        ref={btnRef}
        type="button"
        className={className}
        title={t.themeLabel}
        aria-label={t.themeLabel}
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((o) => !o)}
      >
        <Icon name={resolved === 'dark' ? 'moon' : 'sun'} size={16} />
      </button>
      {open && (
        <div className="theme-menu" role="menu" aria-label={t.themeLabel}>
          {options.map(([value, label, icon]) => (
            <button
              key={value}
              type="button"
              role="menuitemradio"
              aria-checked={pref === value}
              className={'theme-menu-item' + (pref === value ? ' active' : '')}
              onClick={() => { setPref(value); setOpen(false) }}
            >
              <Icon name={icon} size={14} />
              <span>{label}</span>
              {pref === value && <Icon name="check" size={14} className="theme-menu-check" />}
            </button>
          ))}
        </div>
      )}
    </div>
  )
}
